import React, { useState } from 'react';

import CommonImage from '@components/CommonImage';
import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';

import useSingleFileUpload from '@hooks/useSingleFileUpload';

import { adjustTextAreaHeight } from '@utils/Util';

const FactoryPriceApprovalRequestModal = ({ styleCount, onClose, onSubmit }) => {
	const [remarks, setRemarks] = useState('');
	const [attachments, setAttachments] = useState([]);
	const { readFile } = useSingleFileUpload();

	const handleFileChange = async (e) => {
		const files = Array.from(e.target.files || []);
		if (!files.length) return;
		const documentList = await Promise.all(
			files.map(async (file) => ({
				name: file.name,
				base64Str: await readFile(file),
				docMimeType: file.type,
				print: true,
				documentType: 'OTHER'
			}))
		);
		setAttachments((previous) => [...previous, ...documentList]);
		// Reset so the same file can be picked again after being removed.
		e.target.value = '';
	};

	const handleRemoveAttachment = (index) => {
		setAttachments((previous) => previous.filter((item, itemIndex) => itemIndex !== index));
	};

	return (
		<ModalContainer className="factory-price-approval-request-modal">
			<div className="popup-wrapper">
				<div className="common-popup">
					<ModalHeader title="Send factory price for approval" onClose={onClose} />
					<div className="common-popup-body">
						<div className="row">
							{styleCount > 0 && (
								<div className="col-md-12">
									<p className="regular-14 gray_dark_01 mb-12">
										{styleCount} style{styleCount > 1 ? 's' : ''} will be sent to the Head
										of Supply Chain for approval.
									</p>
								</div>
							)}
							<div className="col-md-12">
								<div className="form-group mb-12">
									<label htmlFor="factoryPriceApprovalRemarks">Remarks</label>
									<textarea
										id="factoryPriceApprovalRemarks"
										value={remarks}
										onChange={(e) => setRemarks(e.target.value)}
										rows="3"
										placeholder="Enter your message"
										onInput={(e) => adjustTextAreaHeight(e, '84px')}
									/>
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group mb-12">
									<label htmlFor="factoryPriceApprovalAttachments">Attachments</label>
									<div className="inline-upload">
										<label
											htmlFor="factoryPriceApprovalAttachments"
											className="regular-14 border-gray_dark_01"
										>
											<CommonImage src="/icons/upload-dark.svg" /> Upload
										</label>
										<input
											type="file"
											className="file-upload"
											id="factoryPriceApprovalAttachments"
											name="file"
											multiple
											accept=".jpg,.jpeg,.png,application/pdf"
											onChange={handleFileChange}
										/>
									</div>
								</div>
								<div className="all-pdf-files d-flex flex-wrap justify-content-start align-items-center mb-12">
									{attachments.map((attachment, index) => (
										<div
											key={`${attachment.name}-${index}`}
											className="single-pdf-file d-flex align-items-center mr-4"
										>
											<span className="regular-14 ml-1">{attachment.name}</span>
											<div
												className="acton-img cursor-pointer ml-1"
												onClick={() => handleRemoveAttachment(index)}
											>
												<CommonImage src="/icons/delete_red.svg" width={16} />
											</div>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
					<div className="modal-footer">
						<div className="footer-buttons text-right">
							<button className="button outline size32 ml-2" onClick={onClose}>
								Cancel
							</button>
							<button
								className="button size32 ml-2"
								onClick={() => onSubmit({ remarks: remarks?.trim() || null, attachments })}
							>
								Send for approval
							</button>
						</div>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default FactoryPriceApprovalRequestModal;
